module.exports = __webpack_public_path__ + "img/pro_s1_icon3.35ce9ed4.png";